export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
export function sleepSeconds(seconds) {
  return sleep(1000 * seconds);
}
